var map = {
	"./cop28-de": 333,
	"./cop28-de.json": 333,
	"./cop28-en": 334,
	"./cop28-en.json": 334,
	"./cop28-es": 335,
	"./cop28-es.json": 335,
	"./cop28-ja": 336,
	"./cop28-ja.json": 336,
	"./cop28-ko": 337,
	"./cop28-ko.json": 337,
	"./eu-emissions-focus-de": 338,
	"./eu-emissions-focus-de.json": 338,
	"./eu-emissions-focus-en": 339,
	"./eu-emissions-focus-en.json": 339,
	"./eu-emissions-focus-es": 340,
	"./eu-emissions-focus-es.json": 340,
	"./eu-emissions-focus-ja": 341,
	"./eu-emissions-focus-ja.json": 341,
	"./eu-emissions-focus-ko": 342,
	"./eu-emissions-focus-ko.json": 342,
	"./footer-de": 211,
	"./footer-de.json": 211,
	"./footer-en": 212,
	"./footer-en.json": 212,
	"./footer-es": 213,
	"./footer-es.json": 213,
	"./footer-ja": 214,
	"./footer-ja.json": 214,
	"./footer-ko": 215,
	"./footer-ko.json": 215,
	"./foresight-de": 343,
	"./foresight-de.json": 343,
	"./foresight-en": 344,
	"./foresight-en.json": 344,
	"./foresight-es": 345,
	"./foresight-es.json": 345,
	"./foresight-ja": 346,
	"./foresight-ja.json": 346,
	"./foresight-ko": 347,
	"./foresight-ko.json": 347,
	"./gas-crisis-de": 348,
	"./gas-crisis-de.json": 348,
	"./gas-crisis-en": 349,
	"./gas-crisis-en.json": 349,
	"./gas-crisis-es": 350,
	"./gas-crisis-es.json": 350,
	"./gas-crisis-ja": 351,
	"./gas-crisis-ja.json": 351,
	"./gas-crisis-ko": 352,
	"./gas-crisis-ko.json": 352,
	"./marketing-de": 216,
	"./marketing-de.json": 216,
	"./marketing-en": 217,
	"./marketing-en.json": 217,
	"./marketing-es": 218,
	"./marketing-es.json": 218,
	"./marketing-ja": 219,
	"./marketing-ja.json": 219,
	"./marketing-ko": 220,
	"./marketing-ko.json": 220,
	"./pages-de": 224,
	"./pages-de.json": 224,
	"./pages-en": 225,
	"./pages-en.json": 225,
	"./pages-es": 226,
	"./pages-es.json": 226,
	"./pages-ja": 227,
	"./pages-ja.json": 227,
	"./pages-ko": 228,
	"./pages-ko.json": 228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 576;